import "./caseStudyStyles.css";
import brush from "./brush.svg";
import piece10 from "./Ingles.jpg";
import piece17 from "./current1.png";
import emailicon from "./email-icon.svg";
import hands from "./mag.svg";
import share from "./zap.svg";
import star from "./cart.svg";
import Header from "./Header";
import piece1 from "./current1-annot.png";
import piece2 from "./current2-annot.png";
import piece3 from "./current3-annot.png";
import piece4 from "./current4-annot.png";
import piece5 from "./home-red.png";
import piece6 from "./product-red.png";
import piece7 from "./item-red.png";
import piece8 from "./home-proto-full.png";
import piece9 from "./cart-red.png";
import piece20 from "./products-red-fix.png";
import animationData from "./cart-vid.mp4";
// import piece21 from "./3main.png";
// import piece22 from "./4main.png";
// import piece23 from "./6main.png";
// import piece24 from "./7main.png";
// import piece25 from "./2main.png";
// import piece26 from "./9main.png";
// import piece27 from "./8main.png";
// import piece28 from "./5main.png";
// import piece29 from "./10main.png";

export default function CaseStudy3() {
  return (
    <div class="case-study-page">
      <Header />
      {/* <!-- HERO --> */}
      <section class="hero-section">
        <div class="hero-inner">
          <div class="hero-top">
            <div class="hero-icon">
              <img src={brush} alt="" style={{ color: "white" }} />
            </div>

            <div class="hero-badge">
              <span>SHIPPED</span>
            </div>
          </div>

          <div class="hero-content">
            <h2 style={{ fontSize: "40px" }}>Redesigning the Ingles Markets online grocery shopping experience.</h2>

            <p class="hero-subtitle">
              A UX-focused concept redesign built to reduce friction, improve mobile usability, and modernize the digital grocery experience.
            </p>

            <p class="hero-description">
              Recently, I needed to quickly order milk from my local Ingles Markets. What should have been a simple, two-minute task turned into a
              frustrating experience filled with cluttered navigation, difficult product discovery, and an outdated shopping flow that made even basic
              actions feel unnecessarily complex.
            </p>
          </div>
          <div class="hero-preview">
            <div class="preview-frame" style={{ height: "auto" }}>
              <img
                src={piece10}
                alt="Jason Azevedo LinkedIn"
                style={{ borderRadius: "10px", width: "100%", height: "100%", zIndex: "10", position: "relative" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* <!-- PROJECT META --> */}
      <section class="project-meta">
        <div class="meta-grid">
          <div class="meta-item">
            <span class="meta-label">Product</span>
            <p>Desktop</p>
            <p>Mobile</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">My role</span>
            <p>UX / Product Designer</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">Timeline</span>
            <p>3 Week Concept Project</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">Skills</span>
            <p>Product design, Market Research, Interactive prototyping, User research, Competitor Analysis, E-Commerce</p>
          </div>
        </div>

        <div class="team-row">
          <span class="meta-label">Team</span>

          <p>Jason Azevedo</p>
        </div>
      </section>

      {/* <!-- QUOTE IMAGE --> */}
      <section class="quote-banner">
        <div class="quote-image" style={{ height: "auto" }}>
          <img src={piece17} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />

          {/* <div class="quote-overlay">
            <h2>
              "Handing someone your phone
              <br />
              feel like handing over your whole diary..."
            </h2>
          </div> */}
        </div>
      </section>

      {/* <!-- EXISTING EXPERIENCE --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Existing Experience Audit</h2>
        </div>

        <div class="section-content">
          <p>
            Grocery shopping is a highly task-oriented experience. Users are typically shopping with urgency, building repeat orders, comparing
            prices, and navigating large product catalogs as quickly as possible. The existing experience introduced several interaction and hierarchy
            issues that slowed users down during critical moments of the shopping flow.
          </p>

          <p>
            Across navigation, product discovery, and checkout, the interface often felt visually dense and difficult to scan. Important actions
            competed for attention.
          </p>
        </div>
      </section>

      {/* <!-- CHALLENGE --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>The Challenge</h2>
        </div>

        <div class="section-content">
          <p>
            Extensive and poorly structured shopping experiences, from item discovery to checkout, lead to decision fatigue and user drop-offs.
            Addressing these issue was key to enhancing usability and enabling confident shopping decisions
          </p>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <div class="feature-grid">
              <div class="feature-card" style={{ flexDirection: "column", gap: "6px", alignItems: "flex-start" }}>
                <p style={{ letterSpacing: "2px", color: "rgb(152, 192, 239)", fontWeight: "600" }}>BUSINESS NEED</p>
                <ul
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    paddingLeft: "18px",
                    margin: 0,
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}>
                  <li>Improve cart completion rates</li>
                  <li>modernize the online brand experience</li>
                  <li>increase visibility of time-sensitive offers and savings-driven purchasing behavior</li>
                </ul>
              </div>

              <div class="feature-card" style={{ flexDirection: "column", gap: "6px", alignItems: "flex-start" }}>
                <p style={{ letterSpacing: "2px", color: "rgb(152, 192, 239)", fontWeight: "600" }}>USER NEED</p>
                <ul
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    paddingLeft: "18px",
                    margin: 0,
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}>
                  <li>Quickly find products / clear navigation</li>
                  <li>Build carts efficiently</li>
                  <li>Complete checkout with minimal effort and maximum confidence</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- PROBLEM --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Problem: Inefficient navigation slows down grocery shopping experience</h2>
        </div>

        <div class="section-content">
          <p>
            In grocery shopping, users rely on speed and familiarity to build carts efficiently. They expect to quickly scan / search products,
            compare options, and make confident decisions with minimal effort.
          </p>

          <p>
            In the current Ingles Markets experience, key product information such as pricing, promotions, and differentiation is not consistently
            surfaced at the point of discovery. Additionally, website navigation and search functionalities are not consistent. This evaluation
            process becomes slower and more fragmented, increasing cognitive load during an otherwise routine and repetitive shopping task.
          </p>

          <p style={{ margin: "0" }}>
            To better understand where friction occurs in the grocery shopping experience, I mapped the end-to-end user journey from product discovery
            to checkout. This helped identify how decision-making behavior changes at each stage and where breakdowns in evaluation and cart-building
            occur.
          </p>
        </div>
        <section class="device-showcase" style={{ gap: "30px" }}>
          <h2 style={{ margin: "0" }}>Landing / Home Page</h2>
          <div class="device-frame">
            <img src={piece1} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
          <h2 style={{ margin: "0" }}>Products Page</h2>
          <div class="device-frame">
            <img src={piece2} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
          <h2 style={{ margin: "0" }}>Item Page</h2>
          <div class="device-frame">
            <img src={piece3} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
          <h2 style={{ margin: "0" }}>Cart / Checkout Page</h2>
          <div class="device-frame">
            <img src={piece4} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
        </section>
      </section>

      {/* <!-- RESEARCH --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Research: Understanding Grocery Shopping Behavior</h2>
        </div>

        <div class="section-content">
          <p style={{ margin: 0 }}>
            Based on user behavior patterns observed in grocery shopping flows and UX analysis of e-commerce platforms, I translated key research
            findings into actionable design opportunities focused on reducing friction during product discovery and decision-making.
          </p>

          <div class="research-points">
            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)" }}>Users scan, they don’t read</h3>
              <p>
                Grocery shoppers rarely engage deeply with product pages. Instead, they rely on quick visual cues such as price, imagery, and
                discounts to make fast comparisons.
              </p>
            </div>

            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)" }}>Decision-making happens at the list level</h3>
              <p>
                Users often compare multiple items directly within search or category views rather than opening individual product pages, making
                information hierarchy critical.
              </p>
            </div>

            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)" }}>Promotions strongly influence choice but lack visibility</h3>
              <p>
                Discounts and deals are a key driver in grocery purchasing behavior, but when not clearly surfaced, they are often missed during fast
                scanning behavior.
              </p>
            </div>

            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)" }}>Cart building is non-linear and continuous</h3>
              <p>
                Users constantly adjust quantities, revisit items, and refine decisions while browsing, meaning cart interaction is ongoing rather
                than a final step.
              </p>
            </div>

            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)" }}>Clear navigation is crucial</h3>
              <p>Finding a product within 2-5 seconds should be easy, but finding a better deal during that navigation should be even easier</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Design Principles --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Design Principles</h2>
        </div>

        <div class="section-content">
          <p style={{ margin: 0 }}>
            Based on the behavioral insights gathered throughout the audit and research process, I established a set of guiding design principles to
            shape the redesign experience. These principles focused on reducing friction, supporting fast decision-making, and creating a more
            efficient grocery shopping flow.
          </p>

          <div class="research-points">
            <div class="research-item">
              <h3>Design for scanning, not reading</h3>
              <p>
                Grocery shoppers make rapid decisions while comparing multiple products at once. Product information should be visually prioritized
                and immediately understandable without requiring deep interaction.
              </p>
            </div>

            <div class="research-item">
              <h3>Reduce cognitive load during evaluation</h3>
              <p>
                Key purchasing factors such as pricing, promotions, quantity, and product differentiation should be surfaced clearly to minimize
                unnecessary comparison effort and decision fatigue.
              </p>
            </div>

            <div class="research-item">
              <h3>Support continuous cart-building behavior</h3>
              <p>
                Cart interaction should feel persistent and lightweight throughout the browsing experience, allowing users to adjust decisions quickly
                without interrupting their shopping flow.
              </p>
            </div>

            <div class="research-item">
              <h3>Make promotions feel discoverable and intentional</h3>
              <p>
                Discounts and weekly deals should be integrated naturally into the browsing experience with stronger visual emphasis, helping users
                identify savings opportunities without overwhelming the interface.
              </p>
            </div>

            <div class="research-item">
              <h3>Prioritize speed over visual complexity</h3>
              <p>
                Every interaction should reduce friction between intent and purchase, creating a faster and more confident shopping experience for
                repeat grocery behavior.
              </p>
            </div>

            <div class="research-item">
              <h3>Reduce number of elements crowding navigation</h3>
              <p>
                Every interaction should reduce friction between intent and purchase, creating a faster and more confident shopping experience for
                repeat grocery behavior.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Wireframes --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Wireframes & Exploration</h2>
        </div>

        <div class="section-content">
          <p style={{ marginBottom: "16px" }}>
            With the research and design principles in place, I began exploring low-fidelity wireframes focused on restructuring the shopping flow.
          </p>

          <p style={{ marginBottom: "16px" }}>
            The exploration phase centered on simplifying information hierarchy, reducing unnecessary cognitive load, and surfacing the most important
            shopping actions earlier within the experience.
          </p>

          <p style={{ margin: "0px" }}>
            These early wireframes helped validate layout direction, content prioritization, and navigation structure before moving into
            higher-fidelity interface design.
          </p>
        </div>
        <section class="device-showcase" style={{ gap: "30px" }}>
          <h2 style={{ margin: "0" }}>Landing / Home Page</h2>
          <div class="device-frame">
            <img src={piece5} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
          <h2 style={{ margin: "0" }}>Products Page</h2>
          <div class="device-frame">
            <img src={piece6} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
          <h2 style={{ margin: "0" }}>Item Page</h2>
          <div class="device-frame">
            <img src={piece7} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
          <h2 style={{ margin: "0" }}>Cart / Checkout Page</h2>
          <div class="device-frame">
            <img src={piece9} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
        </section>
      </section>

      {/* <!-- SOLUTION --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Solution: A Faster, More Scannable Grocery Experience</h2>
        </div>

        <div class="section-content">
          <p>
            Rather than treating grocery shopping like traditional e-commerce browsing, the redesigned experience was built around speed-driven
            behavior — helping users quickly search, compare products, identify deals, and complete purchases with minimal friction.
          </p>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <div class="feature-grid">
              <div class="feature-card">
                <p>Simplified Navigation Hierarchy</p>{" "}
              </div>

              <div class="feature-card">
                {" "}
                <p>Faster Product Scanning & Comparison</p>{" "}
              </div>

              <div class="feature-card">
                {" "}
                <p>Clearer Pricing & Promotion Visibility</p>{" "}
              </div>

              <div class="feature-card">
                {" "}
                <p>Streamlined Cart-Building Flow</p>{" "}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- FEATURE BLOCKS --> */}
      <section class="feature-sections">
        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={emailicon} alt="OffMeta Fantasy" style={{ objectFit: "contain" }} />
            </div>
            <h3>Simplifying navigation for faster shopping.</h3>
          </div>
          <div class="feature-copy">
            <p>
              The redesign focused on reducing redundant actions, simplifying the header hierarchy, and making search the primary entry point into the
              shopping experience.
            </p>
            <p>
              Promotional content and secondary actions were reorganized into clearer sections that supported browsing without disrupting
              task-oriented behavior.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={hands} alt="OffMeta Fantasy" style={{ objectFit: "contain", height: "22px" }} />
            </div>
            <h3>Designing product cards for quick comparison.</h3>
          </div>
          <div class="feature-copy">
            <p>
              Grocery shoppers make purchasing decisions within seconds, often comparing multiple products directly from search and category views
              without opening individual product pages.
            </p>
            <p>
              The redesign prioritized product cards as the primary decision-making surface by surfacing clearer pricing hierarchy, stronger
              promotional visibility, quantity details, and faster add-to-cart interactions.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={share} alt="OffMeta Fantasy" style={{ objectFit: "contain", height: "23px" }} />
            </div>
            <h3>Bringing promotional psychology into the digital experience.</h3>
          </div>
          <div class="feature-copy">
            <p>
              Physical grocery stores are intentionally designed around promotional psychology. Endcaps, front-of-store displays, and limited-time
              offers are strategically placed to capture attention and encourage impulse purchases.
            </p>
            <p>
              The redesign translated these retail behaviors into the digital experience by giving promotions stronger visual hierarchy, integrating
              weekly deals naturally into browsing flows, and making savings opportunities easier to discover during product exploration rather than
              hiding them behind separate pages or banners.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={star} alt="OffMeta Fantasy" style={{ objectFit: "contain", height: "21px" }} />
            </div>
            <h3>Supporting continuous cart-building behavior.</h3>
          </div>
          <div class="feature-copy">
            <p>
              Online grocery shopping is rarely a linear experience. Users constantly revisit products, compare alternatives, adjust quantities, and
              refine purchasing decisions throughout the session.
            </p>
            <p>
              The redesign treated cart-building as an ongoing interaction rather than a final checkout step by introducing more lightweight cart
              controls, clearer feedback states, and persistent access to cart information without interrupting browsing behavior.
            </p>
          </div>
        </div>
      </section>

      {/* <!-- DEVICE SHOWCASE --> */}
      <section class="device-showcase">

        <div class="device-frame">
          <img src={piece8} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>

        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece20} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>

        <div class="device-frame" style={{ height: "660px" }}>
          <video autoPlay loop muted playsInline style={{marginTop: "50px"}}>
            <source src={animationData} type="video/mp4" />
          </video>
        </div>
        {/* 
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece21} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece22} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece28} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece23} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece24} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece27} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece26} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece29} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div> */}
      </section>
      {/* <!-- IMPACT --> */}
      <section class="impact-section">
        <div class="impact-content">
          <div class="section-header">
            <h2>Impact: Reducing Friction Across the Grocery Journey</h2>
          </div>

          <div class="section-content">
            <p>
              This concept redesign explored how thoughtful UX decisions can transform a routine grocery task into a faster, more intuitive digital
              experience. Focusing on real shopping behavior rather than traditional e-commerce patterns, the redesign prioritized speed, scanning,
              and low-friction decision-making across the entire journey.
            </p>

            <p>
              Through experience auditing, behavioral research, wireframing, and interface exploration, I identified key breakdowns in navigation,
              product evaluation, promotional visibility, and cart interaction that were slowing users down during critical shopping moments.
            </p>

            <p>
              The final redesign introduced a clearer navigation structure, stronger product hierarchy, improved promotional discoverability, and more
              lightweight cart interactions designed specifically for repeat grocery shopping behavior.
            </p>

            <p>
              Beyond visual modernization, this project reinforced the importance of designing around user intent. Grocery shoppers are not browsing
              for entertainment, they are trying to complete tasks quickly and confidently. Every design decision was made to reduce cognitive load
              and support faster purchasing decisions at scale.
            </p>

            <p>
              <b>I could now comfortably checkout my milk while half asleep using only 4 clicks</b>
            </p>

            {/* <div class="hero-actions">
              <a href="/">
                Google Blog
                <span>↗</span>
              </a>
            </div> */}
          </div>
        </div>

        <div class="impact-mark">
          <img src="/images/mark.svg" alt="" />
        </div>
      </section>
    </div>
  );
}
